import dentalClinic from '@/assets/img/users-cases/dental-clinic.webp';
import dentalClinicHow from '@/assets/img/users-cases/dental-clinic-how.webp';
import dentalClinicResult from '@/assets/img/users-cases/dental-clinic-result.webp';

export default {
  slug: 'dental-clinic',
  order: 21,
  title: 'Dental Clinic 3D View',
  subtitle: 'Dental spaces shown in precise 2D and realistic 3D',
  tags: ['Clinicfloorplans', 'MedicalLayouts'],

  images: {
    hero: dentalClinic,
    aboutTop: dentalClinicHow,
    aboutBottom: dentalClinicResult,
  },

  howText:
    'We put together 2D and 3D dental clinic floor plans and interior design solutions suitable for approvals and presentations.',

  resultText:
    'The project materials help speed up the clinic launch process and streamline communication with contractors and stakeholders.',

  resultExtraText: 'Additionally, we provide:',
  resultList: [
    '2D floor plans for all levels,',
    'a complete 3D visualization of the house,',
    'and a 360° video tour that allows viewers to virtually walk through the space.',
  ],

  tourUrl: null,
  related: [],
};
